<template>
  <b-navbar toggleable="lg" type="dark" variant="primary" v-if="showNav" class="top-nav-app">
    <b-navbar-brand @click.prevent="goToHome()"><img class="logo" src="@/assets/logo.png" alt="logo"></b-navbar-brand>
    <b-navbar-toggle target="nav-collapse" />
    <b-collapse id="nav-collapse" is-nav>
      <b-navbar-nav>
        <b-nav-item v-if="canShowMenu('ENTERPRISE') || canShowMenu('PRINTER') || canShowMenu('SUPERVISOR')" 
                    :class="[ 'home', 'navbar-item', homeDisabled ? 'disabled' : '' ]"
                    :disabled="homeDisabled"
                    @click="sendInstruction({ name: 'home', disableHome: true })">
          <b-icon-house class="w-icon" size="1.1" /> {{ $t('home') }}
        </b-nav-item>
        <template v-if="menu" >
          <b-nav-item v-if="canShowMenu('ENTERPRISE')" class="navbar-item"
                      @click="sendInstruction({ name: 'manageTemplates', disableHome: true })">
            {{ $t('manageTemplates') }}
          </b-nav-item>
          <b-nav-item v-if="canShowMenu('ENTERPRISE') || canShowMenu('SUPERVISOR')" class="navbar-item"
                      @click="sendInstruction({ name: 'findEmployee', disableHome: true })">
            {{ $t('findEmployee') }}
          </b-nav-item>
          <b-nav-item v-if="canShowMenu('ENTERPRISE') || canShowMenu('SUPERVISOR')" class="navbar-item"
          @click="sendInstruction({ name: 'reminder', disableHome: true })">
          {{ $t('reminder') }}
        </b-nav-item>
        <b-nav-item v-if="canShowMenu('ENTERPRISE') || canShowMenu('SUPERVISOR')" class="navbar-item"
                    @click="sendInstruction({ name: 'newBatch', disableHome: true })">
          {{ $t('newBatch') }}
        </b-nav-item>
        </template>

        <template v-if="canShowMenu('GUARD')" >
          <b-nav-item class="navbar-item"
                      @click="sendInstruction({ name: 'showAccessLog', disableHome: false })">
            {{ $t('showAccessLog') }}
          </b-nav-item>
        </template>

        <template v-if="canShowMenu('PRINTER') && menu" >
          <b-nav-item class="navbar-item"
                      @click="sendInstruction({ name: 'managePrinters', disableHome: true })">
            {{ $t('managePrinters') }}
          </b-nav-item>
          <b-nav-item class="navbar-item"
                      @click="sendInstruction({ name: 'manageMachineUsers', disableHome: true })">
            {{ $t('manageMachineUsers') }}
          </b-nav-item>
          <b-nav-item class="navbar-item"
                      @click="sendInstruction({ name: 'printsReport', disableHome: false })">
            {{ $t('printsReport') }}
          </b-nav-item>
        </template>

      </b-navbar-nav>
      
      <b-navbar-nav class="ml-auto">
        <b-nav-item><b v-if="canShowMenu('SUPERVISOR') || canShowMenu('APPROVER')">{{officeName}}</b></b-nav-item>
        <!-- reportes -->
        <b-nav-item-dropdown  v-if="((canShowMenu('ENTERPRISE') && menu) || (canShowMenu('SUPERVISOR') && menu))" :text="$t('reports')" right>
          <b-dropdown-item v-if="canShowMenu('ENTERPRISE') || canShowMenu('SUPERVISOR')" @click="sendInstruction({ name: 'credentialReport', disableHome: false })">
            {{ $t('credentialsReport') }}
          </b-dropdown-item>
          <b-dropdown-item v-if="canShowMenu('ENTERPRISE') && enablePrint" @click="sendInstruction({ name: 'printsReport', disableHome: false })">
            {{ $t('printsReport') }}
          </b-dropdown-item >
        </b-nav-item-dropdown>


        <!-- se agrega enablePrint porque si no está activa para el administrador, no se mostrará nada -->
        <b-nav-item-dropdown v-if="(canShowMenu('SUPERADMIN') && menu)"
                             :text="$t('administration')" right>
          <b-dropdown-item v-if="enableSupervisorProfile && canShowMenu('SUPERADMIN')" @click="sendInstruction({ name: 'manageOffices', disableHome: true })">
            {{ $t('manageOffices') }}
          </b-dropdown-item>                
          <b-dropdown-item v-if="canShowMenu('SUPERADMIN')" @click="sendInstruction({ name: 'manageUsersAdministrators', disableHome: true })">
            {{ $t('manageAdministrators') }}
          </b-dropdown-item>                   
          <b-dropdown-item v-if="enableGuardProfile && canShowMenu('SUPERADMIN')" @click="sendInstruction({ name: 'manageUsers', disableHome: true })">
            {{ $t('manageGuards') }}
          </b-dropdown-item>
          <b-dropdown-item v-if="enableApproverProfile && (enableSystemUserManagementForAdmin || canShowMenu('SUPERADMIN'))" @click="sendInstruction({ name: 'manageUsersApprovers', disableHome: true })">
            {{ $t('manageApprovers') }}
          </b-dropdown-item>
          <b-dropdown-item v-if="canShowMenu('SUPERADMIN')" @click="sendInstruction({ name: 'managePrinterUsers', disableHome: true })">
            {{ $t('managePrinterUsers') }}
          </b-dropdown-item>
          <b-dropdown-item v-if="enableHID && canShowMenu('SUPERADMIN')" @click="sendInstruction({ name: 'keyReport', disableHome: false })">
            {{ $t('keyReport') }}
          </b-dropdown-item>
          <b-dropdown-item v-if="enableHID && canShowMenu('SUPERADMIN')" @click="sendInstruction({ name: 'eventRecover', disableHome: false })">
            {{ $t("eventRecoverHID")}}
          </b-dropdown-item>
        </b-nav-item-dropdown>
        <b-nav-item-dropdown v-if="(canShowMenu('ENTERPRISE') && menu) || (canShowMenu('SUPERADMIN') && menu)"
                             :text="$t('help')" right>
          <b-dropdown-item @click="sendInstruction({ name: 'modalSupport', disableHome: true })">
            {{ $t('support') }}
          </b-dropdown-item>
          <b-dropdown-item @click="sendInstruction({ name: 'modalAbout', disableHome: true })">
            {{ $t('about') }}
          </b-dropdown-item>
        </b-nav-item-dropdown>
        <b-nav-item v-if="login" @click="logout()">
            {{ $t('logout') }} <b-icon-box-arrow-right class="w-icon" size="1.1" />
        </b-nav-item>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script>
import { UserFunctions } from '@/services/loginService'
import { SITES } from '@/constants'
import { jwtDecode } from "jwt-decode";

export default {
  name: 'navBar',
  props: ['expired','tokenData'],
  watch: {
    expired(newVal) {
      if (newVal) {
        this.logout()
      }}
  },
  data() {
    return {
      homeDisabled: true,
      login: false,
      menu: true,
      enableApproverProfile: false,
      enableGuardProfile: false,
      enableHID: false,
      enableSystemUserManagementForAdmin: false,
      token: "",
      enablePrint: false,
      enableSupervisorProfile: false,
      officeName: "",
      tokenDataNavbar: null
    }
  },
  computed: {
    showNav() { 
      this.updateTokenData()
      return !(this.$route.meta.guest || this.$route.meta.noMenu)
     }
  },
  methods: {
    updateTokenData(){
      const token = localStorage.getItem('t8k6ehnq');
      if (token) {
        const parsedToken = JSON.parse(token);
        const jwt = parsedToken.data;
        this.tokenDataNavbar = jwtDecode(jwt);
      }
    
      this.officeName = this.tokenDataNavbar != null ? this.tokenDataNavbar.officeName : ""
    },
    getParams() {
      let siteFolder = this.$route.meta.site ? SITES[this.$route.meta.site].name : document.documentURI.match(/#\/(\w+)\//)[1]
      return this.$route.params.siteFolder ? this.$route.params : { siteFolder }
    },
    goToHome() {
      let home = SITES[this.$route.meta.site]?.home
      if (this.$route.name === home) {
        this.$router.go()
      } else {
        let params = this.getParams()
        this.$router.push({ name: home, params })
      }
    },
    logout() {
      let params = this.getParams()
      UserFunctions.logout()
      this.login = false
      this.$emit('logout');
      if (this.$route.name !== 'login') {
        this.$router.push({ name: 'login', params })
      }
    },
    canShowMenu(category) {
      if(this.tokenData){
        return this.$route.meta.site === category && this.tokenData.usrType === category
      }
      else{
        return false
      }
    },
    hideMenuOptions(payload) {
      this.homeDisabled = payload
      this.menu = payload
    },
    sendInstruction({name, disableHome}) {
      this.homeDisabled = disableHome
      if (name === 'home') {
        this.menu = true
      }
      this.emitter.emit('menu-opt', name)
    }
  },
  mounted() {
    this.login = UserFunctions.isAuthenticated()
  },
  created() {
    //Obtener token
    this.updateTokenData()
    // this.emailLikeID = import.meta.env.VITE_ENABLE_EMAIL_LIKE_ID === 'true'
    this.enableApproverProfile = import.meta.env.VITE_ENABLE_APPROVER_PROFILE === 'true'
    this.enableGuardProfile = import.meta.env.VITE_ENABLE_GUARD_PROFILE === 'true'
    this.enableSupervisorProfile = import.meta.env.VITE_ENABLE_SUPERVISOR_PROFILE === 'true'
    this.enableHID = import.meta.env.VITE_ENABLE_HID === 'true'
    this.enablePrint = import.meta.env.VITE_ENABLE_PRINT === 'true'
    this.enableSystemUserManagementForAdmin = import.meta.env.VITE_ENABLE_SYSTEM_USER_MANAGEMENT_FOR_ADMIN === 'true'
    this.emitter.on('send-login', () => {
      this.login = UserFunctions.isAuthenticated()
    })
    this.emitter.on('menu-show', (payload) => {
      this.hideMenuOptions(payload)
    })
  }
}
</script>